import { render } from "./log-request.vue?vue&type=template&id=2b66f236&scoped=true"
import script from "./log-request.vue?vue&type=script&lang=js"
export * from "./log-request.vue?vue&type=script&lang=js"

import "./log-request.vue?vue&type=style&index=0&id=2b66f236&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Justin\\OneDrive\\OMNIA\\Clients\\R3\\Repos\\R3_vue_web_app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b66f236"]])

export default __exports__